module.exports = __webpack_public_path__ + "components/home-header/static/header-2--small@2x-e7570e2633bfd5e457888a51224bd49b.jpg";